import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var LockedConnectionTooltip = function(props) {
    return /*#__PURE__*/ _jsx(Tooltip, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx(Typography, {
            color: "inherit",
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "m76cTg",
                defaultMessage: [
                    {
                        type: 0,
                        value: "You must be an account owner to connect your POS to Faire"
                    }
                ]
            })
        })
    }));
};
